import { alpha, getToken } from '@optimus-web/core';
import { DENSE_B2B_LIGHT_THEME } from '@optimus-web/theme';

export const COLOR_ACTIONABLE = getToken('paletteBrandIndigo500')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_ACTIONABLE_LIGHT = getToken('paletteBrandNight50')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_ACTION_REQUIRED = getToken('paletteSemanticOrange400')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_DANGER = getToken('paletteSemanticRed600')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_DANGER_LIGHT = getToken('paletteSemanticRed50')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_SUCCESS = getToken('paletteSemanticGreen900')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_TABLE_HEADER_WEEKEND = alpha(
    getToken('paletteBrandNight400')({ theme: DENSE_B2B_LIGHT_THEME }),
    getToken('opacity100')({ theme: DENSE_B2B_LIGHT_THEME })
);

export const COLOR_WHITE = '#ffffff';
export const COLOR_GRAY = getToken('paletteBrandNight200')({ theme: DENSE_B2B_LIGHT_THEME });

// we need to remove it after getting rid of bootstrap and in-field buttons
export const COLOR_LIGHT_GRAY = getToken('paletteBrandNight100')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_BACKGROUND_LIGHT = getToken('paletteBrandNight50')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_BORDER = getToken('paletteBrandNight150')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_TEXT = getToken('paletteBrandNight900')({ theme: DENSE_B2B_LIGHT_THEME });
export const COLOR_TRANSPARENT = 'rgba(255, 255, 255, 0)';

export const TRANSITION_DURATION = 270;
export const EASING_MOVE = 'cubic-bezier(0.4, 0.0, 0.2, 1)';

export const HIDDEN_PRINT = `
    @media print {
        display: none !important;
    }
`;

export const Z_INDEX_APP_NAV_BAR = 100;
export const Z_INDEX_SIDEBAR = 100;
export const Z_INDEX_MODAL_HEADER = 10;
export const Z_INDEX_FLOATING_BUTTON = 10;
export const Z_INDEX_OVERLAY = 110000;

export const HEIGHT_APP_NAV_BAR = '72px';
export const HEIGHT_ACTION_HEADER = '56px';
export const HEIGHT_TABS = '48px';

export const FONT_SIZE_LARGE = '19px';

export const AVATAR_SIZES = '(max-width: 400px) 35vw, (max-width: 650px) 25vw, (max-width: 950px) 20vw, 15vw';
export const AVATAR_ENTITY_SIZES = '(max-width: 400px) 30vw, (max-width: 650px) 20vw, (max-width: 950px) 15vw, 10vw';
export const SUB_AVATAR_SIZES = '(max-width: 400px) 35vw, (max-width: 650px) 25vw, (max-width: 950px) 15vw, 5vw';
export const AVATAR_WIDTH_SET = [240, 320, 480, 640];
export const AVATAR_RATIO = 1;
